import SelectWithCleared from "../../commonComponents/components/selectWithAPI/SelectWithCleared";

const CrewSelect = ({
  label,
  crewFieldName,
  form,
  allSelectedStaffIds = [],
  category = "Cockpit",
  isCockpit = false,
  readOnly
}) => {
  const nameField = `${crewFieldName}_name`;
  const staffIdField = `${crewFieldName}_staff_id`;

  // Exclude everyone else except current field
  const excludedIds = allSelectedStaffIds.filter(
    (id) => id !== form.values[staffIdField] && id != null
  );

  return (
    <SelectWithCleared
      label={label}
      placeholder={`Select ${label}`}
      isCockpit={isCockpit}
      readOnly={readOnly}
      value={form.values[staffIdField] || ""}
      setValue={(value, selectedOption) => {
        if (selectedOption) {
          const [empName, empCode] = selectedOption.label.split(" - ");
          form.setFieldValue(nameField, empName);
          form.setFieldValue(staffIdField, empCode);
        } else {
          form.setFieldValue(nameField, "");
          form.setFieldValue(staffIdField, null);
        }
      }}
      tableName="users"
      itemData={{
        filters: JSON.stringify({
          is_active_eq: true,
          "emp_category_id.category_name_eq": category,
          emp_code_nin: excludedIds,
        }),
        display_options: `["emp_name","emp_code"]`,
        return_value: "emp_code",
      }}
    />
  );
};

export default CrewSelect;
